<template>
    <b-form-select
            name="country"
            v-model="selected"
            :state="state"
        >

        <option :value="null" disabled v-if="placeholder">{{ placeholder }}</option>

        <slot></slot>

    </b-form-select>
</template>

<script>

    export default {

        props: ['error', 'placeholder'],

        data() {
            return {
                selected: null
            }
        },

        computed: {
            state() {
                return this.error ? false : null
            }
        }

    }

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/RSelect.vue